import { ReactNode } from "react";
import ReactModal from "react-modal";

if (process.env.NODE_ENV !== "test") {
  ReactModal.setAppElement("#root");
}

interface ModalProp {
  isOpen: boolean;
  title?: string;
  children: ReactNode;
  onClose: () => void;
  onAfterOpen?: () => void;
}

/**
 * A wrapper for 'react-modal' library.
 */
export function Modal(props: ModalProp) {
  const { isOpen, title, onClose, onAfterOpen, children } = props;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      className="modal"
      overlayClassName="modal-overlay"
      contentLabel="Modal"
      onAfterOpen={onAfterOpen}
    >
      <button className="modal-close" onClick={onClose}>
        <em>X</em>
      </button>
      <div className="modal-header"><em>{title}</em></div>
      <div className="modal-content">{children}</div>
    </ReactModal>
  );
}
